var _defs, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoscii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}.cls-2{font-size:128.02px;font-family:Causten-ExtraBold, Causten;font-weight:800;}.cls-3{letter-spacing:-0.02em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.56,635.36V547.52H492.89A12.11,12.11,0,0,0,505,535.42V370.69a12.11,12.11,0,0,0-12.12-12.1H150.56V64.68H458.67V172.79a12.11,12.11,0,0,0,12.11,12.1H579.07V635.36ZM119.84,382.78H480.78V523.32H119.84Zm363.07-301,79,78.9h-79Zm120.37,90.59c0-.13,0-.27,0-.4a11.38,11.38,0,0,0-.2-1.54h0a11.09,11.09,0,0,0-.41-1.5l-.14-.39a14.36,14.36,0,0,0-.59-1.34l0-.1a13.67,13.67,0,0,0-.82-1.31l-.26-.34a12.81,12.81,0,0,0-1-1.19s0,0,0,0L479.36,44a11.9,11.9,0,0,0-1.22-1c-.11-.08-.22-.17-.33-.24a12.37,12.37,0,0,0-1.33-.84l-.07,0a12.06,12.06,0,0,0-1.38-.61l-.36-.13a12.28,12.28,0,0,0-3.08-.61l-.38,0-.42,0H138.45a12.11,12.11,0,0,0-12.12,12.1v306H107.72a12.11,12.11,0,0,0-12.12,12.1V535.41a12.11,12.11,0,0,0,12.12,12.1h18.61v99.93a12.11,12.11,0,0,0,12.12,12.1H591.18a12.11,12.11,0,0,0,12.12-12.1V172.76c0-.13,0-.27,0-.4Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(130.31 494.61)"
  }, "DO", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 178.21,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 260.65,
    y: 0
  }, "X"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoscii);
export default __webpack_public_path__ + "static/media/doscii.d8f4887b0507f884c809a45aea2167d9.svg";
export { ForwardRef as ReactComponent };